import styled from '@emotion/styled';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { BaseCard } from 'console/shared/styles/mixins/base-card';
const padding = 20;
const gap = 16;
const width = isMediumUI() ? 120 * 1.3 : 120;
export const HeatingModes = styled(BaseCard)(({ length, multiplier }) => ({
    maxWidth: length * width * multiplier + padding + gap,
}));
